import { render, staticRenderFns } from "./RMessage.vue?vue&type=template&id=69818d1a&scoped=true&"
import script from "./RMessage.vue?vue&type=script&lang=js&"
export * from "./RMessage.vue?vue&type=script&lang=js&"
import style0 from "./RMessage.vue?vue&type=style&index=0&id=69818d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69818d1a",
  null
  
)

export default component.exports